import {
    clearPartnerSession,
    getCompanyLogoUrl,
    getPartnerData,
    getPartnerLogoUrl,
    getPartnerToken,
} from '@/lib/api/partner-portal/partner-portal-api'
import { getFileUrl } from '@/lib/utils/file-url'
import { useEffect, useState } from 'react'
import { MdLogout } from 'react-icons/md'
import { Outlet, useNavigate } from 'react-router-dom'

export default function PartnerPortalLayout() {
    const navigate = useNavigate()
    const [partnerName, setPartnerName] = useState('')
    const [logoSrc, setLogoSrc] = useState<string | null>(null)

    useEffect(() => {
        if (!getPartnerToken()) {
            navigate('/person/partners', { replace: true })
            return
        }

        const data = getPartnerData()
        if (data) {
            setPartnerName(data.name || data.tradingName || '')
        }

        const partnerLogo = getPartnerLogoUrl()
        const companyLogo = getCompanyLogoUrl()
        if (partnerLogo) {
            setLogoSrc(partnerLogo)
        } else if (companyLogo) {
            setLogoSrc(getFileUrl(companyLogo))
        }
    }, [])

    const handleLogout = () => {
        clearPartnerSession()
        navigate('/person/partners', { replace: true })
    }

    return (
        <div className="min-h-screen bg-gray-50" data-theme="atendimento">
            <div className="navbar bg-gradient-to-br from-secondary/20 to-white   border-b border-b-primary/20 px-4 lg:px-8">
                <div className="flex-1 flex items-center gap-3">
                    <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-secondary to-secondary/80 flex items-center justify-center overflow-hidden">
                        <img
                            src={logoSrc || '/logo192.png'}
                            alt="Logo"
                            className="w-9 h-9 object-contain"
                        />
                    </div>
                    {partnerName && (
                        <div className="flex-col leading-none text-lg text-secondary font-semibold hidden sm:inline ">
                            {partnerName}
                            <div className="text-[11px] font-bold text-gray-400 uppercase">
                                portal do parceiro
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex-none">
                    <button
                        type="button"
                        className="btn btn-ghost btn-sm gap-2"
                        onClick={handleLogout}
                    >
                        <MdLogout className="text-lg" />
                        <span className="hidden sm:inline">Sair</span>
                    </button>
                </div>
            </div>

            <main className="p-4 lg:p-8">
                <Outlet />
            </main>
        </div>
    )
}
